function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP title
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { title, firstName, middleName, lastName } from '../../actions/index';
import Info from '../info/Info';
import TextInput from '../text-input/TextInput';
import './Name.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Name extends React.Component {
  render() {
    const {
      names,
      firstName,
      lastName,
      middleName
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "Name",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "field-set",
        children: [/*#__PURE__*/_jsx(TextInput, {
          autoComplete: "given-name",
          handleChange: firstName,
          label: "First name",
          name: "firstName",
          onBlur: firstName,
          section: "personal-details",
          values: names
        }), /*#__PURE__*/_jsx(TextInput, {
          autoComplete: "additional-name",
          handleChange: middleName,
          label: "Middle name(s)",
          name: "middleName",
          onBlur: middleName,
          section: "personal-details",
          values: names
        }), /*#__PURE__*/_jsx(TextInput, {
          autoComplete: "family-name",
          handleChange: lastName,
          label: "Last name",
          name: "lastName",
          onBlur: lastName,
          section: "personal-details",
          values: names
        })]
      }), /*#__PURE__*/_jsx(Info, {
        info: "Please enter your name exactly as it appears on your licence."
      })]
    });
  }
}
_defineProperty(Name, "defaultProps", {
  names: {
    firstName: {
      value: ''
    },
    lastName: {
      value: ''
    },
    middleName: {
      value: ''
    },
    title: {
      value: ''
    }
  }
});
const mapStateToProps = ({
  names
}) => {
  return {
    names
  };
};
const mapDispatchToProps = dispatch => {
  return {
    title: value => {
      dispatch(title(value));
    },
    firstName: value => {
      dispatch(firstName(value));
    },
    lastName: value => {
      dispatch(lastName(value));
    },
    middleName: value => {
      dispatch(middleName(value));
    }
  };
};
const VisibleName = connect(mapStateToProps, mapDispatchToProps)(Name);
export default VisibleName;